import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'


function scrollParentToChild(parent, child) {

  // Where is the parent on page
  var parentRect = parent.getBoundingClientRect();
  // What can you see?
  var parentViewableArea = {
    height: parent.clientHeight,
    width: parent.clientWidth
  };

  // Where is the child
  var childRect = child.getBoundingClientRect();
  // Is the child viewable?
  var isViewable = (childRect.left >= parentRect.left) && (childRect.left <= parentRect.left + parentViewableArea.width - childRect.width);

  // if you can't see the child try to scroll parent
  if (!isViewable) {
    // scroll by offset relative to parent
    // parent.scrollLeft = (childRect.left + parent.scrollLeft) - parentRect.left
    $(parent).animate({ scrollLeft: (childRect.left + parent.scrollLeft) - parentRect.left }, 220)
  }
}


let unitSwiper = new Swiper('.element-unit', {
  // effect: 'fade',
  // allowTouchMove: false,
  loop: true,
  loopedSlides: 9,
  pagination: {
    el: '.pagi-unit',
    clickable: true
  },
  navigation: {
    nextEl: '.navi-unit.next',
    prevEl: '.navi-unit.prev',
  },
  on: {
    init: function () {
      $('.unit-tag-list .unit-tag').removeClass('on').eq(this.realIndex).addClass('on')
    },
    slideChangeTransitionStart: function () {
      $('.unit-tag-list .unit-tag').removeClass('on').eq(this.realIndex).addClass('on')
      scrollParentToChild($('.unit-tag-list')[0], $('.unit-tag-list .unit-tag')[this.realIndex])
    }
  }
})

$('.unit-tag-list .unit-tag').click(function () {
  const index = $(this).index()
  unitSwiper.slideToLoop(index)
})


let playSwiper = new Swiper('.how-play', {
  // effect: 'fade',
  // allowTouchMove: false,
  loop: true,
  loopedSlides: 9,
  pagination: {
    el: '.pagi-play',
    clickable: true
  },
  navigation: {
    nextEl: '.navi-play.next',
    prevEl: '.navi-play.prev',
  },
  on: {
    init: function () {
      $('.play-tag-list .play-tag').removeClass('on').eq(this.realIndex).addClass('on')
      $('.how-wrap .summary').text(summaryList[this.realIndex])
    },
    slideChangeTransitionStart: function () {
      $('.play-tag-list .play-tag').removeClass('on').eq(this.realIndex).addClass('on')
      $('.how-wrap .summary').text(summaryList[this.realIndex])
    }
  }
})

$('.play-tag-list .play-tag').click(function () {
  const index = $(this).index()
  playSwiper.slideToLoop(index)
})

$('.unit-list .unit').on('mouseenter', function () {
  const index = $(this).index()
  const detail = guideList[index]

  $('.unit-list .unit').removeClass('hover')
  $(this).addClass('hover')

  $('.guide-pop .type_1').attr('src', detail.type_1)
  $('.guide-pop .type_2').attr('src', detail.type_2)
  $('.guide-pop .more').attr('href', detail.url)

  $('.guide-pop').fadeIn(240)
})

$('.guide-pop').on('mouseleave', function () {
  $('.guide-pop').fadeOut(240)
  $('.unit-list .unit').removeClass('hover')
})

$(document).on('click', function (e) {
  if ($('.guide-pop:visible').length === 0) return
  e.preventDefault()
  $('.guide-pop').fadeOut(240)
  $('.unit-list .unit').removeClass('hover')
})

$('.unit-list').click(function (e) {
  e.stopPropagation()
})